import React from 'react';
import AuthCardLayout from 'layouts/AuthCardLayout';
import WaitlistForm from './components/WaitlistForm';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Waitlist = () => {
  const { t } = useTranslation();
  return (
    <AuthCardLayout
      leftSideContent={
        <p className="pt-3 text-white">
          {t('WAITLIST.ALREADY_APPLIED')}
          <br />
          <Button
            as={Link}
            variant="outline-light"
            className="mt-2 px-4"
            to="/waitlist/status"
          >
            {t('WAITLIST.CHECK_STATUS')}
          </Button>
        </p>
      }
      footer={false}
    >
      <h3>{t('WAITLIST.TITLE')}</h3>
      <p className="text-muted mb-4">
        {t('WAITLIST.SUBTITLE')}
      </p>
      <WaitlistForm />
    </AuthCardLayout>
  );
};

export default Waitlist;
